<template>
  <div class="home">
    <div class="header-outer-box">
      <div class="header-container">
        <div class="search-box-container">
          <SearchBoxIcon itemType="movie"></SearchBoxIcon>
        </div>
        <div class="icon-bookshelf">
        </div>
      </div>
    </div>

    <LoadingComponent v-if="isLoading"></LoadingComponent>
    <div v-if="!isLoading" class="content-box" :key="routerViewKey">
      <div v-for="item in pageItemList" :key="item.id">
        <div v-if="item.unit_type === 2">
          <BannerList :bannerList="item.item" v-if="item.item && item.item.length > 0"></BannerList>
        </div>
        <div v-if="item.unit_type === 4">
          <TabListTwoCol :dataList="item.item" v-if="item.item && item.item.length > 0" :initialActiveTab="activeTab"></TabListTwoCol>
        </div>
      </div>
    </div>

    <div class="settings-switch" @click="onSwitchLineClick">
      <icon-svg icon-class="switchers" class="icon-switcher"></icon-svg>
    </div>
    <ChangeLineActions ref="changeLineAction" @changeLine="onChangeLine"></ChangeLineActions>

    <TabbarComponent></TabbarComponent>
    <EmptyBottom></EmptyBottom>
  </div>
</template>

<script>

  import {Button, Tabs, Tab} from "vant"
  import TabbarComponent from "../../common/TabbarComponent";
  import BannerList from "../../common/BannerList"
  import SearchBoxIcon from "../../common/SearchBoxIcon";
  import ChangeLineActions from "../../common/ChangeLineActions";
  import EmptyBottom from "../../common/EmptyBottom";
  import LoadingComponent from "../../common/LoadingComponent";
  import TabListTwoCol from "../../common/TabListTwoCol";

  export default {
    name: "MovieFeedPage",
    components: {
      TabListTwoCol,
      LoadingComponent,
      EmptyBottom,
      ChangeLineActions,
      BannerList,
      SearchBoxIcon, TabbarComponent, Button, Tabs, Tab,
    },
    data() {
      return {
        curUserInfo: {},

        routerViewKey: 0,
        needShowFeedbackTab: false,

        pageItemList: [],
        isLoading: true,
        activeTab: "",
      };
    },

    mounted() {
      this.initFrontPage()
    },

    activated() {
    },

    computed: {},
    methods: {
      initFrontPage() {
        this.$store.dispatch("FeedDiscoveryPage").then((data) => {
          if (data.code === 0) {
            this.pageItemList = data.data
            this.isLoading = false
          }
        }, () => {
        })
      },

      onSwitchLineClick() {
        this.$refs.changeLineAction.showChangeLine()
      },

      onChangeTab(name, title) {
        this.$router.push({path: name})
      },

      onChangeLine() {
        this.routerViewKey += 1
      },
      //
      // handleScroll(event) {
      //   if (window.innerHeight + window.scrollY > document.body.clientHeight) {
      //     this.showSettings = false
      //     this.showFeedback = false
      //   } else {
      //     this.showSettings = true
      //     this.showFeedback = this.needShowFeedbackTab
      //   }
      // },
    },
    destroyed() {
      // window.removeEventListener('scroll', this.handleScroll);
    },
  };
</script>

<style lang="scss" scoped>
  .home {
    min-height: 100vh;
  }

  .header-outer-box {
    z-index: 1000;
    width: 100%;
    min-height: 62px;
  }

  .content-box {
  }

  .header-container {
    padding: 12px 12px;
    border-bottom: 1px solid #f2f2f2;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .search-box-container {
      flex: 1 1 auto;
    }
  }

  .title-slot {
    line-height: 1.5;
  }

  .active-title-slot {
    font-size: 18px;

    span {
      font-weight: bold;
    }
  }

  .tab-list-container {
    margin-top: 58px;
  }

  .settings-switch {
    color: #000;
    width: 45px;
    font-size: 34px;
    z-index: 100;
    position: fixed;
    right: 14px;
    bottom: 95px;

    .icon-switcher {
      width: 100%;
      color: #fc9153;
    }
  }

</style>


